"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DashboardUserContextRequestModel {
}
exports.DashboardUserContextRequestModel = DashboardUserContextRequestModel;
class DashboardUserContextUdpateRequestModel {
}
exports.DashboardUserContextUdpateRequestModel = DashboardUserContextUdpateRequestModel;
//# sourceMappingURL=dashboard-user-context.request.model.js.map